export const ADMIN_ROUTES = {
  weekView: "/studentList"
}

export const SHARED_ROUTES = {
  home: "/home",
  editStudent: "/edit",
  createStudent: "/booking",
}
